<script lang="ts">
  import { onMount } from "svelte";

  import Tab from "../../components/Tab/Tab.svelte";
  import Tabs from "../../components/Tab/Tabs.svelte";
  import MainLayout from "../../layout/MainLayout.svelte";
import UnpaidInvoices from "./UnpaidInvoices.svelte";
import UnpaidInvoicesEmails from "./UnpaidInvoicesEmails.svelte";

  enum UnpaidPage {
    Unpaid = 1,
    Sentemails
  }

  let currentTab: UnpaidPage = UnpaidPage.Unpaid;

</script>

<MainLayout>
  <Tabs>
    <Tab
      label="Insoluti"
      active={currentTab == UnpaidPage.Unpaid}
      on:click={(_) => {
        currentTab = UnpaidPage.Unpaid;
      }}
    />
    <Tab
        label="Solleciti inviati"
        active={currentTab == UnpaidPage.Sentemails}
        on:click={(_) => {
          currentTab = UnpaidPage.Sentemails;
        }}
      />
  </Tabs>

  {#if currentTab == UnpaidPage.Unpaid}
    <UnpaidInvoices />
  {/if}

  {#if currentTab == UnpaidPage.Sentemails}
    <UnpaidInvoicesEmails />
  {/if} 
</MainLayout>
